import { token } from "../api/client";
import { noteSignInByLink } from "../log/actionLog";

/**
 * ═══ ARRIVER AVEC SA SESSION DANS L'ADRESSE ═══
 *
 * `…/mon-evenement?token=<jwt>` : c'est le mécanisme du produit, pas une invention. Les
 * liens d'invitation de la V1 le portent, et le back-office s'en sert pour ouvrir le
 * site AU NOM d'un participant depuis sa fiche (`pages/user/Details/Token.jsx`, bouton
 * « Se connecter »). Sans lui, la V2 n'était atteignable qu'en connaissant un mot de
 * passe — c'est-à-dire pas du tout, pour l'immense majorité des participants.
 *
 * ⚠️ LE JETON NE RESTE PAS DANS L'ADRESSE. Il vaut session : laissé là, il part dans
 * l'en-tête `Referer` de la première image tierce, se retrouve dans l'historique, dans
 * les favoris, et dans le presse-papiers de quiconque partage « le lien de la page ».
 * On le retire donc de la barre d'adresse dès qu'il est rangé, sans laisser d'entrée
 * d'historique de plus — d'où `replaceState`.
 */

/**
 * Le jeton porté par une adresse, et ce qu'il reste de sa requête une fois retiré.
 *
 * Pure, parce que les cas tordus se vérifient sans navigateur : pas de requête du tout,
 * un jeton vide, et surtout la présence d'AUTRES paramètres — le retour de paiement en
 * porte un (`funnel/payment.ts`), et le perdre en nettoyant ferait dire à la
 * confirmation qu'aucun règlement n'a eu lieu.
 */
export function readTokenFromSearch(search: string): {
  token: string | null;
  rest: string;
} {
  const params = new URLSearchParams(search);
  const raw = (params.get("token") ?? "").trim();
  if (!raw) return { token: null, rest: search };

  params.delete("token");
  const remaining = params.toString();
  return { token: raw, rest: remaining ? `?${remaining}` : "" };
}

/**
 * RANGE LE JETON DE L'ADRESSE, S'IL Y EN A UN — appelé une fois, avant le premier rendu.
 *
 * ⚠️ AVANT REACT, ET C'EST LA CONDITION POUR QUE ÇA SERVE. La toute première requête du
 * site demande QUI EST CONNECTÉ ; partie sans l'en-tête, elle échoue en 401 et le
 * visiteur atterrit sur l'écran de connexion, jeton valide en poche.
 *
 * ⚠️ IL REMPLACE LA SESSION EN PLACE. Un lien nommant quelqu'un est une intention
 * explicite : c'est ainsi que le back-office ouvre le site au nom d'un participant, et
 * garder l'ancienne session ferait regarder le site de la mauvaise personne.
 */
export function adoptTokenFromUrl(): void {
  const { token: received, rest } = readTokenFromSearch(window.location.search);
  if (!received) return;

  token.save(received);
  noteSignInByLink();
  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${rest}${window.location.hash}`,
  );
}
